import {
  ZONE_SET_DATA,
  ZONE_SET_LAST_PAGE,
  ZONE_SET_TOTAL_ROWS,
  ZONE_SET_CURRENT_ROW,
  ZONE_SET_RELOAD_DATA,
  ZONE_SET_LOADING,
  ZONE_TOGGLE_CREATE_EDIT_MODAL,
} from './enums/ZoneTypes';

const initialState = {
  grid: {
    data: [],
    lastPage: 0,
    totalRows: 0,
    reloadData: 0,
    loading: false,
  },
  currentRow: {},
  createEditModal: false,
};

const ZoneReducer = (state = initialState, action) => {
  switch (action.type) {
    case ZONE_SET_DATA:
      return { ...state, grid: { ...state.grid, data: action.data } };
    case ZONE_SET_TOTAL_ROWS:
      return { ...state, grid: { ...state.grid, totalRows: action.data } };
    case ZONE_SET_LAST_PAGE:
      return { ...state, grid: { ...state.grid, lastPage: action.data } };
    case ZONE_SET_LOADING:
      return { ...state, grid: { ...state.grid, loading: action.value } };
    case ZONE_SET_RELOAD_DATA:
      return {
        ...state,
        grid: { ...state.grid, reloadData: state.grid.reloadData + 1 },
      };
    case ZONE_SET_CURRENT_ROW:
      return { ...state, currentRow: action.data };
    case ZONE_TOGGLE_CREATE_EDIT_MODAL:
      return { ...state, createEditModal: !state.createEditModal };
    default:
      return state;
  }
};
export default ZoneReducer;
